export const LAMBDATEST_CAPABILITY_PLATEFORM_LIST_LOADING =
  "LAMBDATEST_CAPABILITY_PLATEFORM_LIST_LOADING";
export const LAMBDATEST_CAPABILITY_PLATEFORM_LIST_SUCCESS =
  "LAMBDATEST_CAPABILITY_PLATEFORM_LIST_SUCCESS";
export const LAMBDATEST_CAPABILITY_PLATEFORM_LIST_FAILED =
  "LAMBDATEST_CAPABILITY_PLATEFORM_LIST_FAILED";
export const LAMBDATEST_CAPABILITY_PLATEFORM_BROWSERS_LIST_LOADING =
  "LAMBDATEST_CAPABILITY_PLATEFORM_BROWSERS_LIST_LOADING";
export const LAMBDATEST_CAPABILITY_PLATEFORM_BROWSERS_LIST_SUCCESS =
  "LAMBDATEST_CAPABILITY_PLATEFORM_BROWSERS_LIST_SUCCESS";
export const LAMBDATEST_CAPABILITY_PLATEFORM_BROWSERS_LIST_FAILED =
  "LAMBDATEST_CAPABILITY_PLATEFORM_BROWSERS_LIST_FAILED";
export const LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_LIST_LOADING =
  "LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_LIST_LOADING";
export const LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_LIST_SUCCESS =
  "LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_LIST_SUCCESS";
export const LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_LIST_FAILED =
  "LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_LIST_FAILED";
export const LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_DEVICE_LIST_LOADING =
  "LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_DEVICE_LIST_LOADING";
export const LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_DEVICE_LIST_SUCCESS =
  "LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_DEVICE_LIST_SUCCESS";
export const LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_DEVICE_LIST_FAILED =
  "LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_DEVICE_LIST_FAILED";
export const LAMBDATEST_CAPABILITY_APPIUM_VERSION_LIST_LOADING =
  "LAMBDATEST_CAPABILITY_APPIUM_VERSION_LIST_LOADING";
export const LAMBDATEST_CAPABILITY_APPIUM_VERSION_LIST_SUCCESS =
  "LAMBDATEST_CAPABILITY_APPIUM_VERSION_LIST_SUCCESS";
export const LAMBDATEST_CAPABILITY_APPIUM_VERSION_LIST_FAILED =
  "LAMBDATEST_CAPABILITY_APPIUM_VERSION_LIST_FAILED";
export const LAMBDATEST_CAPABILITY_UPDATE_CAPABILITY_VALUES =
  "LAMBDATEST_CAPABILITY_UPDATE_CAPABILITY_VALUES";
export const LAMBDATEST_CAPABILITY_DRIVER_LIST_LOADING =
  "LAMBDATEST_CAPABILITY_DRIVER_LIST_LOADING";
export const LAMBDATEST_CAPABILITY_DRIVER_LIST_SUCCESS =
  "LAMBDATEST_CAPABILITY_DRIVER_LIST_SUCCESS";
export const LAMBDATEST_CAPABILITY_DRIVER_LIST_FAILED =
  "LAMBDATEST_CAPABILITY_DRIVER_LIST_FAILED";
export const LAMBDATEST_CAPABILITY_RESET_CAPABILITY_VALUES =
  "LAMBDATEST_CAPABILITY_RESET_CAPABILITY_VALUES";
